const FirehoseStatus = Object.freeze({
  ON: 'ON',
  OFF: 'OFF'
})
export default FirehoseStatus
// RESERVE BELOW
